
import { createStore, applyMiddleware } from 'redux';
import { createLogger } from 'redux-logger';
import programme from './redux/reducers/index';

const configureStore = () => {
  const middlewares = [];

  // NOTE - disabled in production
  if (process.env.NODE_ENV !== 'production') {
    middlewares.push(createLogger());
  }

  return createStore(
    programme,
    applyMiddleware(...middlewares),
  );
};

export default configureStore;




// WEBPACK FOOTER //
// ./src/configureStore.js